export const KARYAWAN = {
  GET_DATA_KARYAWAN_SUCCESS: "GET_DATA_KARYAWAN_SUCCESS",
  LOADING_DATA_KARYAWAN_SUCCESS: "LOADING_DATA_KARYAWAN_SUCCESS",
  LOADING_POST_KARYAWAN_SUCCESS: "LOADING_POST_KARYAWAN_SUCCESS",
};
